import clsx from 'clsx';
import logo from 'assets/images/hp-logo.png';
import styles from './auth-layout.module.scss';

export interface BrandLockupProps {
  /** `dark`: chữ trắng / onNight trên nền Đêm (cột thương hiệu). `light`: chữ đậm trên nền trắng. */
  tone?: 'dark' | 'light';
  /** `md` logo 40px (cột thương hiệu), `sm` logo 36px. */
  size?: 'md' | 'sm';
  className?: string;
}

/**
 * Cụm thương hiệu nằm ngang: logo + "HP Media" + "Quản trị" — cùng mẫu với đầu thanh bên
 * (layouts/components/menu.tsx). Ảnh để alt="" vì ngay cạnh đã có chữ.
 */
const BrandLockup = ({ tone = 'dark', size = 'md', className }: BrandLockupProps) => {
  const px = size === 'sm' ? 36 : 40;
  return (
    <span
      className={clsx(
        styles.lockup,
        tone === 'light' && styles.lockupLight,
        size === 'sm' && styles.lockupSm,
        className
      )}
    >
      <img src={logo} width={px} height={px} alt="" />
      <span className={styles.lockupText}>
        <span className={styles.lockupName}>HP Media</span>
        <span className={styles.lockupRole}>Quản trị</span>
      </span>
    </span>
  );
};

export default BrandLockup;
